<div class="fixed top-0 left-0 right-0 z-50">
  <div
    class="flex flex-row justify-between py-4 px-8 border border-neutral-border bg-neutral-50"
  >
    <img
      src="assets/images/brand/logo-nav.svg"
      alt="declarabid-logo"
      class="w-[221px] h-[61px]"
    />

    <div class="flex flex-row gap-[26px] items-center">
      @if (currentUserRole() === UserRole.admin) {
        <lib-global-button
          type="default"
          label="Instituciones"
          i18n-label
          icon="pi pi-building"
          [routerLink]="'/admin/institutions'"
        />

        <lib-global-button
          type="default"
          label="Usuarios"
          i18n-label
          icon="pi pi-user"
          [routerLink]="['/' + routeUser + '/users']"
        />

        <lib-global-button
          type="default"
          label="Configuración del sistema"
          i18n-label
          icon="pi pi-cog"
          [routerLink]="'/admin/config-system'"
        />
      }

      @if (currentUserRole() !== UserRole.admin) {
        @for (link of items; track $index) {
          <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
        }
      }

      <!-- Selector de idioma -->
      <div class="flex items-center">
        <lib-dropdown-select
          placeholder="Idioma"
          i18n-placeholder
          [options]="languageOptions"
          [selectedValue]="selectedLanguage()"
          [type]="'small'"
          [showClear]="false"
          (selectionChange)="onLanguageChange($event)"
        />
      </div>

      <p-avatar
        class="h-12 flex items-center cursor-pointer"
        image="https://primefaces.org/cdn/primeng/images/demo/avatar/onyamalimba.png"
        shape="circle"
        (click)="menu.toggle($event)"
        onkeypress=""
      ></p-avatar>
    </div>
  </div>
  @if (currentUserRole() === UserRole.admin) {
    <nav
      class="flex justify-between bg-neutral-100 h-[68px] px-8 py-4 shadow-md"
    >
      @if (currentUserRole() === UserRole.admin) {
        @for (link of items; track $index) {
          <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
        }
      }
    </nav>
  }
</div>

<p-menu #menu [popup]="true" [model]="options" appendTo="body"></p-menu>

<p-overlayPanel #op (onHide)="onHide()">
  <app-overlay-notifications />
</p-overlayPanel>
